export class OneRemoteApiError {
  public static fromJSON(json: any) {
    return new OneRemoteApiError(json.status, json.detailedMessage);
  }

  constructor(public readonly status: string, public readonly detailedMessage: string[]) {}
}
